<template>
  <base-layout>
    <div class="common-page my-cards">
      <div class="container-fluid">
        <h1 class="common-page__main-title">{{ $t('myCards') }}</h1>
        <dx-card-manage-filters @filters="onFilters" :disabled="loading" />
        <dx-spinner :active="loading" />
        <div class="my-cards__list" v-if="!loading">
          <dx-card-manage-item
            v-for="card in cards"
            :key="card.id"
            :card="card"
            @edit="onEdit"
            @delete="onDelete"
            />
        </div>
        <dx-paginate
          v-if="paging.pages"
          :pages="paging.pages"
          @change-page="onChangePage"
          />
      </div>
    </div>
  </base-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { BaseLayout } from '../layouts'
import {
  DxButton,
  DxSpinner,
  DxCardManageItem,
  DxCardManageFilters,
  DxPaginate
} from '../components'
export default {
  name: 'my-cards',
  components: {
    BaseLayout,
    DxButton,
    DxSpinner,
    DxCardManageItem,
    DxCardManageFilters,
    DxPaginate
  },
  data () {
    return {
      loading: true,
      page: 1
    }
  },
  methods: {
    ...mapActions([
      'loadMyCards',
      'deleteCard'
    ]),
    onFilters (filters) {
      this.load({ ...filters })
    },
    load (options = {}) {
      this.loading = true
      this.loadMyCards(options).then(() => {
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    onChangePage (page) {
      this.page = page
      this.load({ page })
    },
    onDelete (card) {
      this.deleteCard(card.id).then(() => {
        this.load({ page: this.page })
      })
    },
    onEdit (card) {
      this.$router.push({ name: 'editCard', params: { id: card.id } })
    }
  },
  computed: {
    ...mapGetters({
      cards: 'getMyCards',
      paging: 'getMyCardsPaging'
    })
  },
  created () {
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/MyCards.vue